import request from '@/utils/request'

const api_prefix = '/sms'

// 获取系统配置
export function senSms(data) {
    return request({
        url: api_prefix + '/send',
        method: 'post', // 请求方式
        data
    })
}